import Input from "../../Control/Input";
import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { Wrapper } from "../../Control/Flexbox";
import RefreshIcon from "@material-ui/icons/Refresh";
import { ExpandLess, ExpandMore, Remove, Add } from "@material-ui/icons";

const QualifiedLab = (props) => {
  const { ppapData } = props;
  const [render, setRender] = useState(false);
  const [isSpecs, setIsSpecs] = useState([]);
  function handleSpec(e, index) {
    const value =
      e.target.type === "checkbox" ? e.target.checked : e.target.value;
    ppapData.qualified_labs[index][e.target.name] = value;
  }

  function append(where, data) {
    ppapData[where].push(data);
    setRender((prev) => !prev);
  }

  function remove(where, index) {
    if (window.confirm("Are you sure you want to delete Qualified Lab?")) {
      ppapData[where].splice(index, 1);
      setRender((prev) => !prev);
    }
  }

  const hideSpecs = (index) => {
    setIsSpecs((prev) => [...prev, index]);
  };

  const openSpecs = (index) => {
    const values = [...isSpecs];
    const idx = values.indexOf(index);
    values.splice(idx, 1);
    setIsSpecs(values);
  };

  return (
    <div className="specs-container" style={{ marginBottom: "3rem" }}>
      <Wrapper>
        <Input
          type="text"
          name="name_of_lab"
          label="Name of Laboratory"
          onChange={(e) => {
            ppapData.name_of_lab = e.target.value;
          }}
          defaultValue={ppapData.name_of_lab}
        />
        <Input
          type="text"
          name="loa"
          label="Lab appointed operator"
          onChange={(e) => {
            ppapData.loa = e.target.value;
          }}
          defaultValue={ppapData.loa}
        />
      </Wrapper>
      <div>
        <Wrapper
          justify="space-between"
          style={{ borderBottom: "1px solid #c80202" }}
        >
          <p className="card-btn-para" style={{ color: "#c80202" }}>
            • ADD{" "}
            <span style={{ fontWeight: 400, color: "black" }}>
              QUALIFIED LAB
            </span>
          </p>
          <Wrapper>
            <Wrapper
              style={{
                height: "45px",
                width: "50px",
                backgroundColor: "#c80202",
                color: "white",
                cursor: "pointer",
              }}
              onClick={() => {
                append("qualified_labs", {
                  s_no: ppapData.qualified_labs.length + 1,
                });
              }}
              justify="center"
            >
              <Add />
            </Wrapper>
            <Wrapper
              style={{
                height: "45px",
                width: "50px",
                backgroundColor: "#151a1d",
                color: "white",
                cursor: "pointer",
              }}
              justify="center"
              onClick={() => {
                ppapData?.qualified_labs?.sort(
                  (a, b) => Number(a.s_no) - Number(b.s_no)
                );
                setRender((prev) => !prev);
              }}
            >
              <RefreshIcon />
            </Wrapper>
          </Wrapper>
        </Wrapper>
      </div>

      {ppapData.qualified_labs.map((spec, index) => (
        <div
          key={uuidv4()}
          style={{
            marginBottom: "0.3rem",
            marginTop: "0.6rem",
            padding: "0rem",
            border: "1px solid #f0f2f0",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              background: "#fafafa",
              alignItems: "center",
            }}
            className="spec-header"
          >
            <Wrapper>
              <Input
                type="Number"
                name="s_no"
                onBlur={(e) => handleSpec(e, index)}
                defaultValue={spec.s_no}
                style={{ width: "80px" }}
              />
              <Wrapper
                justify="center"
                style={{
                  marginLeft: "0.4rem",
                  fontSize: "0.9rem",
                  textTransform: "uppercase",
                }}
              >
                {spec.name_of_inst}
              </Wrapper>
            </Wrapper>
            <Wrapper>
              {isSpecs.includes(index) ? (
                <Wrapper
                  style={{
                    height: "45px",
                    width: "50px",
                    backgroundColor: "#3f51b5",
                    cursor: "pointer",
                    color: "white",
                  }}
                  justify="center"
                  onClick={() => openSpecs(index)}
                >
                  <ExpandLess />
                </Wrapper>
              ) : (
                <Wrapper
                  style={{
                    height: "45px",
                    width: "50px",
                    backgroundColor: "#3f51b5",
                    cursor: "pointer",
                    color: "white",
                  }}
                  justify="center"
                  onClick={() => hideSpecs(index)}
                >
                  <ExpandMore />
                </Wrapper>
              )}
              <Wrapper
                style={{
                  height: "45px",
                  width: "50px",
                  backgroundColor: "#151a1d",
                  color: "white",
                  cursor: "pointer",
                }}
                justify="center"
                onClick={() => remove("qualified_labs", index)}
              >
                <Remove />
              </Wrapper>
            </Wrapper>
          </div>
          {isSpecs.includes(index) && (
            <div className="specs-field">
              <Wrapper>
                <Input
                  type="text"
                  name="name_of_inst"
                  placeholder="Name of inst."
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.name_of_inst}
                />
                <Input
                  type="text"
                  name="item_no"
                  placeholder="Item No."
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.item_no}
                />
                <Input
                  type="text"
                  name="brand_name"
                  placeholder="Brand Name"
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.brand_name}
                />
                <Input
                  type="text"
                  name="function"
                  placeholder="Function"
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.function}
                />
                <Input
                  type="text"
                  name="remarks"
                  placeholder="Remarks"
                  onBlur={(e) => handleSpec(e, index)}
                  defaultValue={spec.remarks}
                />
              </Wrapper>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
export default QualifiedLab;
